// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App2';
import theme from './theme';
import { LoadsProvider } from './context/LoadsContext';

// ✅ Make sure this path matches your file structure
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}>
    <LoadsProvider>
    {/* AuthProvider must wrap everything that uses useAuth() */}
    <AuthProvider>
          <BrowserRouter>
          <App />
          </BrowserRouter>
    </AuthProvider>
    </LoadsProvider>
  </ChakraProvider>
);
